import { z } from "zod";


export const ReajusteCadastroSchema = z.object({
    idReajuste: z.coerce.number().nonnegative(),
    idIndiceReajuste: z.coerce.number().nonnegative(),
    percentual: z.coerce.number(),
    status: z.coerce.boolean().default(true),
    idsContratosFinanceiroIgnorados: z.array(z.coerce.number()).optional(),
    aplicarEntrada: z.coerce.number().default(0),

    mesIndice: z.coerce.number().default(1),
    mesReajuste: z.coerce.number().default(1),
    anoReajuste: z.coerce.number().default(new Date().getFullYear()),

});

export type ReajusteCadastroForm = z.infer<typeof ReajusteCadastroSchema>;

export const defaultReajusteCadastroForm: Partial<ReajusteCadastroForm> = {
    status: true,
    idReajuste: 1,
    mesIndice: 1,
    percentual: undefined,
    idsContratosFinanceiroIgnorados: [],
    aplicarEntrada: 0,

    mesReajuste: 1,
    anoReajuste: new Date().getFullYear(),

}